/* DONNERKRAFT Relaunch: kleine Helfer (Fade-in, Accordion, Sticky-Bar) */
(function () {
  document.documentElement.classList.add('dk-js');
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }) : null;
  function init() {
    document.querySelectorAll('.dk-fade').forEach(function (el) { if (io) io.observe(el); else el.classList.add('is-in'); });
    document.querySelectorAll('.dk-faq details').forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        var group = d.closest('.dk-faq');
        if (!group || group.dataset.multi === 'true') return;
        group.querySelectorAll('details[open]').forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
